import { pieceName } from '@halvard/board3d';
import { squareName, type Action, type GameState } from '@halvard/rules';
import { resultText } from './pieceInfo';

/** A sentence describing an action, for the aria-live region. Uses the state before the action. */
export function describeAction(before: GameState, pieceId: string, action: Action): string {
  const piece = before.pieces.find((p) => p.id === pieceId);
  if (!piece) return '';
  const who = pieceName(piece);
  const from = squareName(piece.r, piece.c);
  const to = squareName(action.r, action.c);
  switch (action.kind) {
    case 'move':
      return `${who} moves ${from} to ${to}.`;
    case 'capture': {
      const target = before.pieces.find((p) => p.id === action.target);
      return `${who} on ${from} captures ${target ? pieceName(target) : 'a piece'} on ${to}.`;
    }
    case 'pin': {
      const target = before.pieces.find((p) => p.id === action.pin);
      return `${who} pins ${target ? pieceName(target) : 'a piece'} on ${to}.`;
    }
    case 'build': {
      const height = (before.heights[action.r]?.[action.c] ?? 0) + action.delta;
      return `${who} ${action.delta > 0 ? 'raises' : 'lowers'} ${to} to height ${height}.`;
    }
  }
}

/** Announcement after a state change, including the result when the game ended. */
export function describeOutcome(state: GameState): string {
  if (state.winReason === null) return '';
  const { title, detail } = resultText(state.winner, state.winReason);
  return `${title}. ${detail}`;
}
